import React from "react";
import dynamic from "next/dynamic";

import Box from "@mui/material/Box";

import color from "@definitions/mui/color";

import { ILayoutMobileProps } from "./Layout.types";

const LayoutHeader = dynamic(() => import("./Header"), { ssr: false });
const Navigation = dynamic(() => import("./Navigation"), { ssr: false });

const isAllowLogin = (process.env.NEXT_PUBLIC_ALLOW_LOGIN ?? "true") === "true";

const Layout: React.FC<ILayoutMobileProps> = ({ page, children, layoutType }) => {
  const withHeaderCriterias = [
    layoutType === "noHeader",
    layoutType === "isAccountPage",
    layoutType === "noMenuTopBottom",
  ];

  return (
    <Box>
      {withHeaderCriterias.includes(true) ? null : (
        <Box height="56px">
          <LayoutHeader isAllowLogin={isAllowLogin} layoutType={layoutType} />
        </Box>
      )}
      <Box
        padding={
          layoutType === "noMenu" || layoutType === "noMenuTopBottom"
            ? 0
            : page === "subscribed"
              ? "56px 0 58px 0"
              : page === "home"
                ? "0px 0 58px 0"
                : layoutType === "noPaddingX"
                  ? "32px 0 58px 0"
                  : layoutType === "noHeader"
                    ? "0 0 58px 0"
                    : layoutType === "afterSubscribed"
                      ? "24px 0 74px 0"
                      : "32px 16px 74px 16px"
        }
        style={{ backgroundColor: color.white, minHeight: "100vh" }}
      >
        {children}
        {layoutType === "noMenu" || layoutType === "noMenuTopBottom" ? null : <Navigation />}
      </Box>
    </Box>
  );
};

export default Layout;
